import { combineReducers } from "redux";
import cartReducers from "./reducer";
import totalReducer from '../total/reducer'

export default combineReducers({
    cart: cartReducers,
    total: totalReducer,
});


// WEBPACK FOOTER //
// ./src/components/Cart/Reducers/index.js